/* ==========================================================================
   Landing — Tarjetas de producto
   - Animación de entrada al aparecer la sección.
   - Modal «Test café»: calcula cafés/mes y bolsas, y al aplicar configura la
     suscripción de la tarjeta (plan mensual + nº de bolsas) y cierra el modal.
     Equivalencia: 500 g = 60 cafés.
   La compra (toggle, cantidades, envío gratis, carrito) la gestiona
   landing-featured-product.js sobre cada tarjeta [data-lfp].
   ========================================================================== */
(function () {
  'use strict';

  if (window.__ebocaCards) return;
  window.__ebocaCards = true;

  var CAFES_PER_500G = 60;
  var DAYS_PER_MONTH = 30;

  function cafesPerBag(grams) {
    return Math.max(1, Math.round((grams * CAFES_PER_500G) / 500));
  }

  /* ---------- Sección ---------- */
  function Cards(root) {
    this.root = root;
    this.modal = root.querySelector('[data-lct]');
    this.dialog = this.modal && this.modal.querySelector('.lct__dialog');
    this.card = null;
    this.lastFocus = null;
    root.__lc = this;

    this.reveal();
    if (this.modal) this.bindModal();
  }

  Cards.prototype.reveal = function () {
    var root = this.root;
    var settle = function () {
      root.classList.add('is-inview');
      setTimeout(function () { root.classList.add('is-settled'); }, 1800);
    };
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      settle();
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        settle();
        io.disconnect();
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    io.observe(root);
  };

  /* ---------- Modal ---------- */
  Cards.prototype.bindModal = function () {
    var self = this;

    this.root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lcards-test]');
      if (trigger) {
        self.open(trigger.closest('[data-lfp]'), trigger);
        return;
      }
      if (e.target.closest('[data-lct-close]')) {
        self.close();
        return;
      }
      if (e.target.closest('[data-lct-apply]')) {
        self.apply();
      }
    });

    this.modal.addEventListener('change', function (e) {
      if (e.target.matches('[data-lct-people], [data-lct-cups]')) self.calculate(true);
    });

    document.addEventListener('keydown', function (e) {
      if (!self.modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') self.close();
      if (e.key === 'Tab') self.trapFocus(e);
    });
  };

  Cards.prototype.open = function (card, trigger) {
    this.card = card;
    this.lastFocus = trigger || document.activeElement;
    this.calculate(false);
    this.modal.removeAttribute('inert');
    this.modal.setAttribute('aria-hidden', 'false');
    this.modal.classList.add('is-open');
    document.documentElement.classList.add('lct-lock');
    var dialog = this.dialog;
    setTimeout(function () { dialog.focus({ preventScroll: true }); }, 60);
  };

  Cards.prototype.close = function (restoreFocus) {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    this.modal.setAttribute('inert', '');
    document.documentElement.classList.remove('lct-lock');
    if (restoreFocus !== false && this.lastFocus && this.lastFocus.focus) {
      this.lastFocus.focus({ preventScroll: true });
    }
  };

  Cards.prototype.trapFocus = function (e) {
    var items = Array.prototype.filter.call(
      this.dialog.querySelectorAll('button, input, [href], [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === this.dialog)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  Cards.prototype.value = function (selector) {
    var input = this.modal.querySelector(selector + ':checked');
    return input ? parseFloat(input.value) : 0;
  };

  /* Cafés/día = personas × cafés que toma cada persona al día */
  Cards.prototype.calculate = function (animate) {
    var people = this.value('[data-lct-people]') || 1;
    var cups = this.value('[data-lct-cups]') || 1.5;
    var perDay = people * cups;
    var cafesMonth = Math.round(perDay * DAYS_PER_MONTH);

    var lfp = this.card && this.card.__lfp;
    var grams = lfp && lfp.gramsPerBag ? lfp.gramsPerBag() : 500;
    var perBag = cafesPerBag(grams);
    var bags = Math.max(1, Math.ceil(cafesMonth / perBag));

    this.result = { bags: bags, months: 1 };

    var bagsEl = this.modal.querySelector('[data-lct-bags]');
    var text = bags + (bags === 1 ? ' bolsa' : ' bolsas');
    if (bagsEl.textContent !== text) {
      bagsEl.textContent = text;
      if (animate) {
        bagsEl.classList.remove('is-bump');
        void bagsEl.offsetWidth;
        bagsEl.classList.add('is-bump');
      }
    }
    this.modal.querySelector('[data-lct-cafes]').textContent = cafesMonth;
    var note = this.modal.querySelector('[data-lct-note]');
    if (note) {
      note.textContent = 'Bolsas de ' + grams + ' g (' + perBag + ' cafés cada una). Calculado con la equivalencia 500 g = 60 cafés, unos 8 g de café recién molido por taza.';
    }
  };

  Cards.prototype.apply = function () {
    var card = this.card;
    var result = this.result;
    this.close(false);
    if (!card || !card.__lfp || !result) return;

    // Lleva la tarjeta a la vista si hace falta y aplica la configuración
    var rect = card.getBoundingClientRect();
    if (rect.top < 0 || rect.top > window.innerHeight * 0.6) {
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    setTimeout(function () {
      card.__lfp.applyConfig({ qty: result.bags, months: result.months });
      var cta = card.querySelector('[data-lfp-cta]');
      if (cta) cta.focus({ preventScroll: true });
    }, 250);
  };

  /* ---------- Init ---------- */
  function init(scope) {
    (scope || document).querySelectorAll('[data-lcards]').forEach(function (root) {
      if (!root.__lc) new Cards(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
